<div class="flex flex-col justify-between items-center py-2 gap-5 w-full h-full">
  <div class="flex flex-col w-full gap-2">
    <div class="flex justify-center items-start w-full gap-1.5">
      <mat-form-field appearance="outline" class="w-full max-w-20 !min-w-20" [subscriptSizing]="'dynamic'">
        <mat-label>Código</mat-label>
        <mat-select panelWidth="" [(value)]="selectedCountryCode">
          <mat-select-trigger>
            <img with="21px" height="21px" src="{{ selectedCountryCode.src }}">
          </mat-select-trigger>
          <mat-option [value]="countryCode" *ngFor="let countryCode of countryCodes">
            <img with="21px" height="21px" src="{{ countryCode.src }}">
            <span> {{ countryCode.dial_code }} {{ countryCode.name }} </span>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-full" floatLabel="always" [subscriptSizing]="'dynamic'">
        <mat-label>Número de teléfono</mat-label>
        <span matTextPrefix class="pr-1 text-primary">{{ selectedCountryCode.dial_code }}</span>
        <input (click)="onPhoneNumberTouched()" type="number" inputmode="numeric" matInput placeholder="912345678" (ngModelChange)="onPhoneNumberChange($event)" [formControl]="phoneControl" maxLength="12">
        <mat-error *ngIf="getFirstErrorMessage()">{{ getFirstErrorMessage() | translate }}</mat-error>
      </mat-form-field>
    </div>
    <div *ngIf="!getFirstErrorMessage() && !phoneControl.value && hint" class="flex items-start mx-2 gap-1 text-xs text-light-gray">
      <mat-icon svgIcon="ph-regular-info" class="icon-xxxsm text-light-gray mt-0.5 shrink-0"></mat-icon>
      <span>
        {{ hint }}
      </span>
    </div>
  </div>
  <div class="flex flex-col w-full">
    <button mat-raised-button color="accent" class="flex items-center justify-center w-full" [disabled]="disabled" (click)="sendPhoneNumber()">
      <span class="flex items-center">
        <span class="mx-3">Obtener código</span>
      </span>
    </button>
  </div>
</div>
